import { isValidElement, type ReactElement } from "react";
import { warnOnce } from "../../internal/functions";

/**
 * Logs a dev-only deprecation warning when `error` is passed as a `ReactElement`.
 * String values are the preferred type and are NOT deprecated.
 * Should be called in consumer components that accept the union `error` prop.
 */
export function warnDeprecatedErrorUsage(
  componentName: string,
  error: ReactElement | string | boolean | string[] | undefined,
): void {
  if (error === undefined || typeof error === "boolean") return;
  if (typeof error === "string" || Array.isArray(error)) return;

  // At this point, error is a ReactElement
  if (isValidElement(error)) {
    warnOnce(
      `[Anvil2 ${componentName}] Passing a ReactElement to the \`error\` prop is deprecated. ` +
        `Use a string or string[] instead: \`error="message"\` or \`error={["msg1", "msg2"]}\`. ` +
        `See https://beta.anvil.servicetitan.com/docs/web/components/field-message/code`,
    );
  }
}
